import { FC, useEffect, useState } from "react"
import { Actions, ControlProps } from "@jsonforms/core"
import { withJsonFormsControlProps } from "@jsonforms/react"
import { useJsonForms } from "@jsonforms/react"
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material"

import { UText } from "../../../ui-component"
import InputSummary from "../NewForm/InputSummary"
import { generateSummary } from "../NewForm/formUtils"

import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { checkIfObjectHasKeys } from "@/core/utils/formatters"

const UArchesTreatCheckbox: FC<ControlProps> = (props) => {
  const { schema, path, label, data, visible, handleChange } = props
  const { core, dispatch } = useJsonForms()
  const [errors, setErrors] = useState("")
  const [updatedSchema, setUpdatedSchema] = useState<object>({})
  const [updatedData, setUpdatedData] = useState(data || [])
  const { caseDetail, caseList } = useAppSelector((state: RootState) => state.caseService)

  const handleCheckboxChange = (value: string) => {
    let checkBoxValues = [...updatedData]
    const index = checkBoxValues.indexOf(value)
    if (index === -1) {
      checkBoxValues.push(value)
    } else {
      checkBoxValues.splice(index, 1)
    }

    const newData = checkBoxValues
    setUpdatedData(newData)
  }

  const validateCustomField = () => {
    if (core?.schema.required?.indexOf(path) === -1 || !visible) {
      return
    }
    updateErrors(updatedData.length ? "" : "This is a required field")
  }

  const updateErrors = (message: string) => {
    setErrors(message)
    dispatch &&
      dispatch(
        Actions.updateErrors([
          {
            instancePath: "/" + path,
            message,
            schemaPath: "",
            keyword: "",
            params: {},
          },
        ]),
      )
  }

  useEffect(() => {
    handleChange(path, updatedData)
  }, [updatedData])
  

  useEffect(() => {
    if (!visible) {
      setUpdatedData([])
      updateErrors("")
    } else if (core?.schema.required?.indexOf(path) !== -1) {
      updateErrors("This is a required field")
    }
  }, [visible])

  useEffect(() => {
    validateCustomField()
  }, [updatedData, core?.validationMode])
  
    useEffect(() => {
      if (
        caseList[0]?.udesign_json || caseDetail.udesign_json
      ){
        // In Refinement form 1, make the arches_to_treat values Upper and Lower present 
        // if only the respective stl in uploaded and make it uneditably checked.
        const udesign_json = JSON.parse(caseDetail.udesign_json)
        let archesToTreatSchema = {
          ...schema,
          checkboxes: schema.checkboxes ? [...schema.checkboxes] : []
        };
        let archesToTreatData = []
        if( ["A", "R"].includes(udesign_json.UpperType) || udesign_json.upperUploaded ){
          archesToTreatData.push('upper')
        }else{
          archesToTreatSchema = {...archesToTreatSchema, checkboxes: archesToTreatSchema.checkboxes.filter(arch=>arch.value!=="upper")}
        }

        if( ["A", "R"].includes(udesign_json.LowerType) || udesign_json.lowerUploaded ){
          archesToTreatData.push('lower')
        }else{
          archesToTreatSchema = {...archesToTreatSchema, checkboxes: archesToTreatSchema.checkboxes.filter(arch=>arch.value!=="lower")}

        }

        if(!archesToTreatSchema.isCheckBoxGroupDisabled){
          archesToTreatSchema.isCheckBoxGroupDisabled = true
          setUpdatedSchema(archesToTreatSchema)
        }
        setUpdatedData(archesToTreatData)
      }
    }, [caseList, schema, caseDetail])
    

  return (
    <>
      {visible && schema?.summary ? (
        <InputSummary label={label} inputVal={generateSummary(schema,data)} />
      ) : (
        visible && (
          <FormControl
            error={!!(errors && core?.validationMode === "ValidateAndShow")}
            sx={{ my: 1, display: "flex", flexDirection: "row", pl: 1 }}
          >
            <UText
              variant={"body2"}
              sxProp={{
                minWidth: 200,
                maxWidth: 200,
                marginTop: 1,
                color:
                  errors && core?.validationMode === "ValidateAndShow"
                    ? "error.main"
                    : "text.secondary",
              }}
            >
              {label}
            </UText>
            <Box>
              <FormGroup sx={{ pl: 1 }}>
                {checkIfObjectHasKeys(updatedSchema) && updatedSchema.checkboxes.map(
                  (item: { label: string; value: string }, index: number) => {
                    
                    return (
                      <Box key={index}>
                        <FormControlLabel
                          sx={{
                            display: "inline-flex",
                            alignItems: "flex-start",
                            width: "fit-content",
                            pointerEvents: "none",
                            "& .MuiFormControlLabel-label": {
                              display: "inline-flex",
                              alignItems: "flex-start",
                              width: "fit-content",
                              pointerEvents: "none",
                              "& .MuiFormControlLabel-label": {
                                display: "inline-flex",
                                pointerEvents: "none",
                                pt: "10px",
                              },
                            }}
                          }
                          key={item.value}
                          control={
                            <Checkbox
                              checked={
                                updatedData
                                  ? schema.type === "array"
                                    ? updatedData.length &&
                                      updatedData.indexOf(item.value) > -1
                                    : updatedData.value.indexOf(item.value) > -1
                                  : false
                              }
                              onChange={() => {
                                !updatedSchema.isCheckBoxGroupDisabled &&
                                  handleCheckboxChange(item.value)
                              }}
                              sx={{
                                pointerEvents: "auto",
                                "&.Mui-checked": {
                                  color: updatedSchema.isCheckBoxGroupDisabled && "grey", // Checked color
                                },
                              }}
                              name={item.value}
                            />
                          }
                          label={
                            <span
                              style={{
                                display: "inline-flex",
                                pointerEvents: "auto",
                                paddingTop: "10px"
                              }}
                            >
                              {item.label}
                            </span>
                          }
                        />
                      </Box>
                    )
                  },
                )}
                {errors && core?.validationMode === "ValidateAndShow" && (
                  <FormHelperText sx={{ marginLeft: 0 }}>
                    {errors}
                  </FormHelperText>
                )}
              </FormGroup>
            </Box>
          </FormControl>
        )
      )}
    </>
  )
}

export default withJsonFormsControlProps(UArchesTreatCheckbox)